import { model } from '../core/model'
import primerAcceso from "../controllers/primerAcceso"
import yaTiene from '../controllers/yaTiene'
import tieneDeuda from '../controllers/tieneDeuda'
import pdfSuscriptoSinPDF from "../controllers/pdfSuscriptoSinPDF";
import Analitycs from '../helpers/analytics'
import Hotjar from "../helpers/hotjar";
import { Config } from '../core/config'
import view from '../helpers/view'

const flowA = (data) => {
    switch (data.code) {
        case '07': //TIENE DEUDA
            console.log('Tiene Deuda');
            tieneDeuda();
            break;
        case '08': //YA TIENE SUSUCRIPCION DIGITAL
            console.log('Controller.yaTenia() .Redirect a CallBack');
            yaTiene();
            break;
        case '04': //NO ASOCIADO
        case '13': //CLASSIC
        case '14': 
        case '26': 
        case '30': 
        case '31': 
            view.hidePreloader();
            console.log('flowA-Logueado-No pasa naranja');
            flowDefault();
            break;
        case '25': //PREMIUM TITULAR
        case '28': //BLACK TITULAR
            console.log('View.primerAcceso() - Redirect a Bonificado');
            primerAcceso();
            break;
        case '0001':
            window.mostrar_error( { 
                error: `flowHandler.flowA | Error inesperado ${data.code}` 
            })   
            break;
        default:
            window.mostrar_error( { 
                error: `flowHandler.flowA | Salida no contemplada ${data.code}` 
            })   
            break;
        }
        
}

const flowAPdf = (data) => {
    switch (data.code) {
        case '07': //TIENE DEUDA
            console.log('Tiene Deuda');
            tieneDeuda();
            break;
        case '08': //YA TIENE SUSUCRIPCION DIGITAL
            if (!model.Usuario.hasPDF())
            {
                console.log("Cambiar el mensaje del wall de PDF - pdfSuscriptoSinAcceso")
                pdfSuscriptoSinPDF();
            }
            else
            {
                console.log('Controller.yaTenia() .Redirect a CallBack');
                yaTiene();
            }
            break;
        case '04': //NO ASOCIADO
        case '13': //CLASSIC
        case '14': 
        case '26': 
            view.hidePreloader();
            Analitycs.paginaVirtual(model.Window.source);
            console.log('View.pdfSinSuscripcion()'); //deberia ser el default que venga renderizado
            break;
        case '30': 
        case '31': 
            view.hidePreloader();
            console.log('flowA-Logueado-No pasa naranja');
            Analitycs.paginaVirtual(model.Window.source);
            break;
        case '25': //PREMIUM TITULAR
        case '28': //BLACK TITULAR
            console.log('View.primerAcceso() - Redirect a Bonificado');
            primerAcceso();
            break;
        case '0001':
            window.mostrar_error( { 
                error: `flowHandler.flowAPDF | Error inesperado ${data.code}` 
            }) 
            break;
        default:
            window.mostrar_error( { 
                error: `flowHandler.flowAPDF | Salida no contemplada ${data.code}` 
            })
            break;
        }
        
}

const flowABis = (data) => {
    switch (data.code) {
        case '04': //NO ASOCIADO
        case '13': //CLASSIC
        case '14': 
        case '26': 
        case '30': 
        case '31': 
            console.log('View.noTieneSuscripcion');
            flowDefault();
            view.hidePreloader();
            break;
        case '07': //TIENE DEUDA
            console.log('Tiene Deuda');
            tieneDeuda();
            break;
        case '08': //YA TIENE SUSUCRIPCION DIGITAL
            console.log('Controller.yaTenia() .Redirect a CallBack');
            yaTiene();
            break;
        case '25': //PREMIUM TITULAR
        case '28': //BLACK TITULAR
            console.log('View.primerAcceso() - Redirect a Bonificado');
            primerAcceso();
            break;
        case '0001':
            window.mostrar_error( { 
                error: `flowHandler.flowABis | Error inesperado ${data.code}` 
            }) 
            break;
        default:
            window.mostrar_error( { 
                error: `flowHandler.flowABis | Salida no contemplada ${data.code}` 
            })
            break;
        }
        
}

const flowDefault = () => {
    Analitycs.paginaVirtual(model.Window.source);
    Hotjar.callTrigger(Config.HotjarHeatmapWall);
}

export default {
    flowA, 
    flowAPdf,
    flowABis,
    flowDefault
};




// WEBPACK FOOTER //
// ./Statics/scripts/paywall/handlers/flow.js